export const AUTOPILOT_USER_UUID = '6316f5bb-5858-4345-92ed-04566c1d7f54';
